import { render, staticRenderFns } from "./mainadd.vue?vue&type=template&id=58d5ecf2&scoped=true"
import script from "./mainadd.vue?vue&type=script&lang=js"
export * from "./mainadd.vue?vue&type=script&lang=js"
import style0 from "./mainadd.vue?vue&type=style&index=0&id=58d5ecf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d5ecf2",
  null
  
)

export default component.exports